import React, {Component} from "react";
import {Box, Button, Checkbox, Divider, Paper, Popper, Stack, Tooltip} from "@mui/material";
import {DoubleLeftOutlined, DoubleRightOutlined} from "@ant-design/icons";
import Typography from "@mui/material/Typography";
import {connect} from "react-redux";
import {
    changeGammaViewUrl,
    isNull,
    limitString,
    linkViewer,
    notNull,
    openEndPoint,
    openInNewTab
} from "../../../utils/utils";
import {error_manager} from "../../../helper/error_manager";
import {morphleBaseTheme1} from "../themes";
import {OpenInNewRounded} from "@mui/icons-material";
import {componentIds, Loader, responsiveLayers} from "../../../utils/const";
import {animateToState} from "../utils/map_utils";
import {convertMapStateToUrlParams} from "../utils/linkMakerUtils";
import {checkAppPermission} from "../utils/gammaScanUtils";
import {capReport, caseInfoApp} from "../app_maker";
import ReportApp from "./cap_report";
import {get} from "../../../helper/request";
import {mapSlides, reset, toggleSync} from "../utils/splitSyncUtils";
import {addScreenshotToReport} from "../utils/screenshot_utils";
import FileScreenshotsList from "./FileScreenshotsList";
import {deleteFile} from "../utils/fileUtils";
import {updateKeyboardShortcuts} from "../../../redux_actions/morpheus.setting.action";
import {CASE_STATUS} from "../../../const/cases_const";
import {changeDisplayedSlide} from "../../../redux_actions/maps.state.action";
import {store} from "../../../helper/store";
import {withRouter} from "react-router-dom";
import {clearAllSlidesFromSplitSyncView} from "../../../redux_actions/splitSyncSlides.action";
import {updateCaseIdx, updateDisplayedMap, updatePatientFolder} from "redux_actions/gamma.state.action";
import {openFolderEndpoint} from "utils/endpoint_utils";
import {aclPermissions, hasPermissions} from "const/ACLPermissions";
import {getAdjacentCases} from "../../../redux_actions/cases.action";
import {fetchCase, markCaseSlideRead, removeCaseFile} from "../../../redux_actions/case.action";
import {Loading} from "../components/components";


class CaseInfo extends Component {

    constructor(props) {
        super(props);

        this.state = this.initState();
        this.ref = React.createRef();
        this.permanentSlideRef = React.createRef();
        this.noSlideLoaded = false
        this.caseId = this.props.slide?.case || this.getCaseIdFromQueryParams()
    }

    isIpad = () => document.documentElement.clientWidth <= responsiveLayers.LEVEL_3

    getCaseIdFromQueryParams = () => {
        const queryParams = new URLSearchParams(window.location.search)
        return queryParams.get("case_id")
    }

    initState = () => {
        //Keep original state of keyboard_shortcut app
        this.keyboardShortcutEnabled = this.props.keyboard_shortcuts?.["enabled"] || false;
        return {
            showCapReport: false,
            currCaseIndex: -1,
            openSplitViewDisabled: false,
            prevCase: null,
            nextCase: null,
            currentCaseIndex: -1,
            totalCases: 0,
            isNextSkipped: false,
            isPrevSkipped: false,
            isFetching: false,
            fetchingAdjacentCases: false
        };
    }

    fetchCase = (id = this.props.slide.case) => {
        this.props.dispatch(fetchCase(id, false))
    }

    fetchFirstSlideAndOpen = (case_id) => {
        get(`/api/slideforlink/?case__id=${case_id}&view=link`)
            .then(data => data?.[0])
            .then(slide => {
                if (slide?.id === this.props.caseState.case?.id) return

                if (!slide) {
                    linkViewer({id: "no-slide"}, `??topApp=${caseInfoApp.id}&case_id=${case_id}`)
                    return
                }

                linkViewer(slide, `??topApp=${caseInfoApp.id}`)
            })
    }

    checkAllCaseSlides = () => this.props.caseState.case?.slides?.forEach(slide => slide.checked = true);

    checkCaseSlide = (slide, checked) => {
        slide.checked = checked;
        this.setState({
            currSlideIndex: this.props.caseState.case?.slides?.findIndex(slide => slide?.id === this.props.slide?.id),
            totalSlides: this.props.caseState.case?.slides?.length,
            unreadSlides: this.props.caseState.case?.slides?.filter(slide => slide?.unread).length,
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ((isNull(prevProps.caseState.case) && notNull(this.props.caseState.case)) || (notNull(prevProps.caseState.case) && notNull(this.props.caseState.case) && prevProps.caseState.case.id !== this.props.caseState.case.id)) {
            this.setState({
                currSlideIndex: this.props.caseState.case?.slides?.findIndex(slide => slide?.id === this.props.slide?.id),
                totalSlides: this.props.caseState.case?.slides?.length,
                unreadSlides: this.props.caseState.case?.slides?.filter(slide => slide?.unread).length,
            }, this.checkAllCaseSlides)

            const folder = this.props.caseState.case.patient_folder || {}
            const caseIdx = Array.isArray(this.props.caseState.case?.patient_folder?.cases) ?
                this.props.caseState.case?.patient_folder.cases?.findIndex(({id}) => id === this.props.caseState.case?.id)
                : -1

            if (this.props.folder && folder !== {} && caseIdx !== -1) {
                this.props.dispatch(updatePatientFolder(this.props.caseState.case.patient_folder))
            }
            this.props.dispatch(updateCaseIdx(caseIdx))
            this.setState({
                isFetching: false
            })
        }
        if (prevState.unreadSlides !== this.props.caseState.case?.slides?.filter(slide => slide?.unread).length) {
            this.setState({
                unreadSlides: this.props.caseState.case?.slides?.filter(slide => slide?.unread).length
            })
        }
        if (prevProps.slide !== this.props.slide) {
            let currSlideIndex = 0;
            if (this.state && this.props.caseState.case) {
                currSlideIndex = this.props.caseState.case.slides.findIndex(slide => slide.id === this.props.slide.id);
            }
            this.setState({currSlideIndex: currSlideIndex});
        }

        const case_id = this.props.folder.cases?.[this.props.caseIdx]?.id
        if (prevProps.caseIdx !== this.props.caseIdx &&
            this.props.caseIdx !== -1 &&
            case_id &&
            case_id !== this.props.caseState.case?.id) {
            this.fetchFirstSlideAndOpen(case_id)
        }
        if (prevProps.slide?.case_id !== this.props.slide?.case_id && !this.props.caseState.loading) {
            if (this.state.showCapReport) {
                this.setState({
                    openCapReport: true
                })
                this.toggleCapReport()
            }
            if (isNull(this.props.slide?.case_id.length) || this.props.slide?.case_id.length === 0) {
                this.setState(this.initState)
                return
            }

            this.fetchCase();
            this.getAdjacentCasesData();

        }
    }

    componentDidMount() {
        // this.scrollCaseInfoToPermanentSlide();

        this.caseId && this.fetchCase(this.caseId);
        this.getAdjacentCasesData();

        if (!!this.getCaseIdFromQueryParams()) {
            error_manager("No Slide Present in this Case", {})
        }
    }

    getAdjacentCasesData = () => {
        this.setState({fetchingAdjacentCases: true})
        this.props.slide?.case && getAdjacentCases(this.props.slide.case, this.props.slide.id, (result) => {
            this.setState({
                prevCase: result["prev_case"], nextCase: result["next_case"],
                totalCases: result['total'], currentCaseIndex: result['current_index'], fetchingAdjacentCases: false,
                isNextSkipped: result['is_next_skip'], isPrevSkipped: result['is_prev_skip']
            });
        });
    }

    componentWillUnmount() {
        if (this.keyboardShortcutEnabled) {
            this.props.dispatch(updateKeyboardShortcuts({...this.props.keyboard_shortcuts, enabled: true}));
        }

        this.props.dispatch(updatePatientFolder({}))
        this.props.dispatch(updateCaseIdx(-1))
    }

    scrollCaseInfoToPermanentSlide = () => {
        if (this.permanentSlideRef !== null && this.permanentSlideRef.current !== null) {
            this.permanentSlideRef.current.scrollIntoView();
        }

        return null;
    }


    goToPrevSlide = () => {
        if (this.state.currSlideIndex > 0) {
            changeGammaViewUrl(this.props, this.props.slide.id, this.props.caseState.case.slides[this.state.currSlideIndex - 1].id, true);
            store.dispatch(changeDisplayedSlide(this.props.caseState.case.slides[this.state.currSlideIndex - 1]));
            this.setState({
                currSlideIndex: this.state.currSlideIndex - 1,
                openSplitViewDisabled: false
            })
            this.props.dispatch(clearAllSlidesFromSplitSyncView())
        }
    }

    goToPrevCaseSlide = () => {
        if (this.state.showCapReport) {
            this.setState({
                openCapReport: true,
            })
            this.toggleCapReport();
        }
        this.setState({
            isFetching: true
        }, () => {
            changeGammaViewUrl(this.props, this.props.slide.id, this.state.prevCase?.first_slide_meta.id, true);
            store.dispatch(changeDisplayedSlide(this.state.prevCase?.first_slide_meta));
            this.props.dispatch(clearAllSlidesFromSplitSyncView())
            this.getAdjacentCasesData();
            this.setState({
                openSplitViewDisabled: false
            })
        })
    }

    goToNextCaseSlide = () => {
        if (this.state.showCapReport) {
            this.setState({
                openCapReport: true,
            })
            this.toggleCapReport()
        }
        this.setState({
            isFetching: true
        }, () => {
            changeGammaViewUrl(this.props, this.props.slide.id, this.state.nextCase?.first_slide_meta.id, true);
            store.dispatch(changeDisplayedSlide(this.state.nextCase?.first_slide_meta));
            this.props.dispatch(clearAllSlidesFromSplitSyncView())
            this.getAdjacentCasesData();
            this.setState({
                openSplitViewDisabled: false
            })
        })

    }

    goToPrevCase = () => {
        const updatedCaseIdx = this.props.caseIdx - 1
        if (updateCaseIdx < 0) return
        this.props.dispatch(updateCaseIdx(updatedCaseIdx))
    }

    goToNextSlide = () => {
        if (this.state.currSlideIndex < this.props.caseState.case.slides.length - 1) {
            changeGammaViewUrl(this.props, this.props.slide.id, this.props.caseState.case.slides[this.state.currSlideIndex + 1].id, true);
            store.dispatch(changeDisplayedSlide(this.props.caseState.case.slides[this.state.currSlideIndex + 1]));
            this.setState({
                currSlideIndex: this.state.currSlideIndex + 1,
                openSplitViewDisabled: false
            })
            this.props.dispatch(clearAllSlidesFromSplitSyncView())
        }
    }

    goToNextCase = () => {
        const updatedCaseIdx = this.props.caseIdx + 1
        if (updatedCaseIdx >= this.props.folder.cases.length) return
        this.props.dispatch(updateCaseIdx(updatedCaseIdx))
    }

    goToCase = (e, caseId = this.props.caseState.case?.id) => openFolderEndpoint();

    viewTrf = () => openInNewTab(
        `/case-files/${this.props.caseState.case.case_id}/case_trf/${this.props.caseState.case.case_id}_trf.pdf`);

    split = () => {
        this.setState({
            openSplitViewDisabled: true
        })
        store.dispatch(updateDisplayedMap(null));

        mapSlides([this.props.caseState.case.slides[this.state.currSlideIndex],
            ...this.props.caseState.case.slides.filter(slide => slide.checked && slide.id !== this.props.slide?.id)])
    };

    addScreenshotToCase = () => addScreenshotToReport(
        componentIds.slideMaps,
        this.props.slide,
        this.props.activeMapId,
        this.props.extension,
        this.props.displaySetting,
        JSON.stringify({
            mapState: {
                x: this.props.x,
                y: this.props.y,
                z: this.props.z,
                r: this.props.r,
            },
        }),
        ""
    );

    deleteScreenshotFromCase = screenshot => deleteFile(screenshot).then(() => {
            store.dispatch(removeCaseFile(screenshot.id))
        }
    );

    limitString = (str, limit) => {
        if (str.length <= limit - 3) return str
        return `${str.slice(0, limit - 3)}...`
    }

    isSlideInCurrentCase() {
        const slideId = this.props.loadingState.slideId;
        const currentCaseSlides = this.props.caseState.case.slides
        for (let i = 0; i < currentCaseSlides.length; i++) {
            if (currentCaseSlides[i].id === slideId) {
                return true;
            }
        }
        return false;
    }

    getCaseNumberComponent = () => this.props.caseIdx >= 0 ?
        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} spacing={0.5}>
            <LargeBtn disabled={this.props.caseIdx <= 0} onClick={this.goToPrevCase}>
                <DoubleLeftOutlined/>
                <span>Case</span>
            </LargeBtn>
            <Stack sx={{width: 0.5}} direction={"column"} alignItems={"center"}>
                <Typography color={"whitesmoke"} textAlign={"center"}>
                    {`Case ${this.props.caseIdx + 1} of ${this.props.folder.cases.length}`}
                </Typography>
                <Typography color={"whitesmoke"}>
                    {this.props.folder.folder_name}
                </Typography>
            </Stack>
            <LargeBtn disabled={this.props.caseIdx === this.props.folder.cases.length - 1}
                      onClick={this.goToNextCase}>
                <span>Case</span>
                <DoubleRightOutlined/>
            </LargeBtn>
        </Stack>
        : <></>

    getPrevNextCaseComponent = () => {
        return <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
            <Tooltip title={this.state.isPrevSkipped && <Typography sx={{fontSize: 10}}>
                Previous case will be skipped <br/> as it does not contain any slide</Typography>}>
                <Button variant={"outlined"} color={"secondary"} style={{fontSize: "20px", padding: "16px"}}
                        disabled={isNull(this.state.prevCase)} onClick={this.goToPrevCaseSlide}>
                    <DoubleLeftOutlined/> Case
                </Button>
            </Tooltip>
            <Stack sx={{width: 0.5}} direction={"column"} alignItems={"center"}>
                <Typography color={"whitesmoke"} textAlign={"center"}>
                    {`Case ${this.state.currentCaseIndex} of ${this.state.totalCases}`}
                </Typography>
            </Stack>
            <Tooltip title={this.state.isNextSkipped && <Typography sx={{fontSize: 10}}>
                Next case will be skipped <br/> as it does not contain any slide</Typography>}>
                <Button variant={"outlined"} color={"secondary"} style={{fontSize: "20px", padding: "16px"}}
                        disabled={isNull(this.state.nextCase)} onClick={this.goToNextCaseSlide}>
                    Case <DoubleRightOutlined/>
                </Button>
            </Tooltip>
        </Stack>
    }

    getSlideNumberComponent = () => <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
        <LargeBtn disabled={this.props.loadingState.loading || this.state.currSlideIndex <= 0}
                  onClick={this.goToPrevSlide}>
            <DoubleLeftOutlined/> Slide
        </LargeBtn>
        <Stack sx={{width: 0.5}} direction={"column"} alignItems={"center"}>
            <Typography color={"whitesmoke"} textAlign={"center"}>
                {`Slide ${this.state.currSlideIndex + 1} of ${this.state.totalSlides}`}
            </Typography>
            <Typography color={"whitesmoke"}>
                {`(${this.state.unreadSlides} unread)`}
            </Typography>
        </Stack>
        <LargeBtn
            disabled={this.props.loadingState.loading || this.state.currSlideIndex === this.state.totalSlides - 1}
            onClick={this.goToNextSlide}>
            Slide <DoubleRightOutlined/>
        </LargeBtn>
    </Stack>

    toggleCapReport = () => {

        let shortcuts = this.props.keyboard_shortcuts;
        // Turn off keyboard shortcuts while editing CAP report as it activates them while typing
        if (!this.state.showCapReport) {
            if (this.keyboardShortcutEnabled) {
                this.props.dispatch(updateKeyboardShortcuts({...shortcuts, enabled: false}));
            }
        } else {
            if (this.keyboardShortcutEnabled) {
                this.props.dispatch(updateKeyboardShortcuts({...shortcuts, enabled: true}));
            }
        }

        this.setState({
            showCapReport: !this.state.showCapReport
        });
    }

    getCapReportApp = () => checkAppPermission(capReport) ?
        <>
            <Button color={"secondary"} variant={"outlined"} size={"small"} onClick={this.toggleCapReport}
                    disabled={!hasPermissions([aclPermissions.update_cap_report])}
            >
                Edit CAP Report
            </Button>
            <Popper placement="right" open={this.state.showCapReport} anchorEl={this.ref.current?.parentElement}>
                <Paper sx={{height: "71vh", width: "41vw", borderRadius: 0, backgroundColor: "#200445"}}>
                    <ReportApp slideData={this.props.slide} onCAPReportClose={this.toggleCapReport}/>
                </Paper>
            </Popper>
        </> : null;


    getCaseComponentIpad = () => {
        return <Stack direction={"row"} spacing={1} justifyContent={"space-between"}>
            <Stack direction={"row"} alignItems={"center"} spacing={0.5}>
                <Button color={"secondary"} variant={"outlined"} size={"small"} onClick={this.goToCase}
                        height={"100%"}>
                    Go to Folders
                </Button>
            </Stack>

            <Divider orientation="vertical"/>

            <Stack direction={"column"} spacing={0.5}>
                {[
                    ["Folder Name", this.props.caseState.case?.case_id],
                    ["Patient Name", this.props.caseState.case?.patient_name],
                    ["DOB/SEX", this.props.caseState.case?.age_and_sex],
                    ["SAMPLE ID", this.props.caseState.case?.slides[this.state.currSlideIndex]?.name],
                ].map(row =>
                    <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                        <Typography sx={{color: 'white', fontWeight: 700}}>{row[1]}</Typography>
                    </Stack>
                )}
            </Stack>
        </Stack>
    }

    getCaseComponent = () =>
        <Stack direction={"column"}>
            {[
                ["Folder Name", this.props.caseState.case?.case_id],
                ["Patient Name", this.props.caseState.case?.patient_name],
                ["DOB/SEX", this.props.caseState.case?.age_and_sex],
                ["SAMPLE ID", this.props.caseState.case?.slides[this.state.currSlideIndex]?.name],

            ].map(row =>
                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                    <Typography sx={{color: 'white', fontWeight: 700}}>{row[0]}</Typography>
                    <Typography sx={{color: 'white', fontWeight: 500}}>{row[1]}</Typography>
                </Stack>
            )}
            <Stack direction={"row"} alignItems={"center"} justifyContent={"space-evenly"} marginTop={1}
                   spacing={0.5}>
                <Button color={"secondary"} variant={"outlined"} size={"small"} onClick={this.goToCase}>
                    Go to Folders
                </Button>
                {this.getCapReportApp()}
                <Tooltip title={!this.props.caseState.case.trf_uploaded && "TRF not uploaded"}>
                    <Button color={"secondary"} variant={"outlined"} size={"small"} onClick={this.viewTrf}
                            disabled={!this.props.caseState.case.trf_uploaded}>
                        <span>View TRF</span>
                    </Button>
                </Tooltip>
            </Stack>
        </Stack>

    getRelatedScansComponent = () =>
        <Stack direction={"column"} spacing={0.5}>
            {/* <Typography color={"secondary"} sx={{textAlign: 'center'}}>Scans related to this case</Typography> */}
            <Box maxHeight={"12vh"} overflow={"auto"}>
                {this.props.caseState.case?.slides.length > 0 ? this.props.caseState.case.slides.map((slide, index) =>
                        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                            <Stack direction={"row"} alignItems={"center"} spacing={1}>
                                <Checkbox
                                    ref={slide.id === this.props.permanentSlide?.id ? this.permanentSlideRef : null}
                                    defaultChecked size={"small"} sx={{padding: 0}} color={"secondary"}
                                    onClick={(e) => this.checkCaseSlide(slide, e.target.checked)}
                                    disabled={this.state.currSlideIndex === index}
                                    checked={slide.id === this.props.slide.id || slide.checked}
                                />
                                <Typography width={150} sx={{color: 'white', fontWeight: 250}}>
                                    {limitString(slide.name, 22)}
                                </Typography>
                            </Stack>
                            {this.state.currSlideIndex !== index ?
                                <Button sx={{color: morphleBaseTheme1.palette.text.primary, minWidth: 10, padding: 1}}
                                        edge="end"
                                        onClick={() => linkViewer(slide, `??topApp=${caseInfoApp.id}`, true)}>
                                    <OpenInNewRounded fontSize={"small"}/>
                                </Button> : null
                            }
                        </Stack>
                    ) :
                    <Typography width={150} sx={{color: 'white', fontWeight: 250}}>
                        No Slides Present
                    </Typography>
                }
            </Box>
            <Tooltip followCursor={true} title={this.props.totalMaps < 2 && "Open Split View to use sync"}>
                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-evenly"} spacing={0.5}>
                    <Button color={"secondary"} variant={"outlined"} size={"small"} onClick={this.split}
                            disabled={this.props.caseState.case.slides.filter(slide => slide.checked || slide.id === this.props.slide?.id).length < 2 || this.state.openSplitViewDisabled || isNull(this.props.displayedMapId)}>
                        Open Split View
                    </Button>
                    <Button color={"secondary"} variant={"outlined"} size={"small"} onClick={toggleSync}
                            disabled={!isNull(this.props.displayedMapId)}>
                        <span>{this.props.sync ? "Unsync" : "Sync"}</span>
                    </Button>
                    <Button color={"secondary"} variant={"outlined"} size={"small"} onClick={() => {
                        reset()
                        this.setState({
                            openSplitViewDisabled: false
                        })
                    }}
                            disabled={!isNull(this.props.displayedMapId)}>
                        <span>Reset</span>
                    </Button>
                </Stack>
            </Tooltip>
        </Stack>

    getRelatedCasesComponent = () =>
        !this.props.folder.cases ? <></> :
            <Stack direction={"column"} spacing={0.1}>
                <Box maxHeight={"12vh"} overflow={"auto"}>
                    {this.props.folder.cases?.map((c, idx) =>
                        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                            <Stack direction={"row"} alignItems={"center"} spacing={1}>
                                <Typography width={150} sx={{color: 'white', fontWeight: 250}}>
                                    {limitString(c.case_id, 22)}
                                </Typography>
                            </Stack>
                            <Button sx={{color: morphleBaseTheme1.palette.text.primary, minWidth: 10}}
                                    disabled={c.id === this.props.folder.cases[this.props.caseIdx]?.id}
                                    edge="end" onClick={() => this.props.dispatch(updateCaseIdx(idx))} size="small">
                                <OpenInNewRounded fontSize={"small"}/>
                            </Button>
                        </Stack>
                    )}
                </Box>
            </Stack>

    getScreenshotComponent = () =>
        <FileScreenshotsList files={this.props.caseState.case_files}
                             showOnHover={true}
                             height={"15vh"}
                             onClick={file => file.slide === this.props.slide.id ?
                                 animateToState(this.props.slidemap.getView(), file.meta.mapState) :
                                 openEndPoint(`/gamma/${file.slide}?${convertMapStateToUrlParams(
                                     {slide: {id: file.slide}, ...file.meta.mapState})}`, true, true)}
                             onAdd={!(this.props.abstract_configs['lockCapReport'] &&
                                 this.props.caseState.case['case_status'] === CASE_STATUS.REPORT_GENERATED) ? this.addScreenshotToCase : null}
                             onDelete={this.deleteScreenshotFromCase}
        />

    render() {
        if (isNull(this.props.slide))
            return <Loading/>
        if (isNull(this.props.slide?.case))
            return <Typography>No case associated with this slide</Typography>;

        if (this.props.caseState?.error?.response?.status === 403) {
            return <Typography>You do not have the ACL Permission to view this case. Please contact your admin to gain access.</Typography>
        }

        if (isNull(this.props.caseState.case) || this.state.isFetching || this.state.fetchingAdjacentCases || this.props.caseState.loading || (this.props.loadingState.loading && !this.isSlideInCurrentCase())) {
            return <Loader/>
        }

        return <Stack ref={this.ref} direction={"column"} spacing={0.5} height={"100%"}>
            {this.isIpad() ? this.getCaseComponentIpad() : null}
            {this.getCaseNumberComponent()}
            {this.getRelatedCasesComponent()}
            {!this.isIpad() ? this.getCaseComponent() : null}
            {!this.isIpad() ? this.getScreenshotComponent() : null}
            {this.getPrevNextCaseComponent()}
            {this.getSlideNumberComponent()}
            {this.getRelatedScansComponent()}
        </Stack>
    }


}

const
    mapStateToProps = (state) => {
        let caseState = state.caseReducer;
        let loadingState = state.slideLoadingReducer;
        let gammaState = state.gammaStateReducer;
        let {activeMapId, displayedMapId, sync, folder, caseIdx} = gammaState;
        let mapsState = state.mapsStateReducer;
        let {slide, slidemap, displaySetting, x, y, z, r} = mapsState[activeMapId] ?? {};
        let permanentSlide = Object.values(mapsState)[0].slide;
        let totalMaps = Object.keys(mapsState).length;
        let {extension} = state.screenshotStateReducer;
        let {keyboard_shortcuts, abstract_configs} = state.morpheusSettingReducer;
        return {
            activeMapId,
            slidemap,
            slide,
            permanentSlide,
            sync,
            totalMaps,
            extension,
            displaySetting,
            x,
            y,
            z,
            r,
            keyboard_shortcuts,
            folder,
            caseIdx,
            abstract_configs,
            displayedMapId,
            loadingState,
            caseState
        };
    };

export default connect(mapStateToProps)

(
    withRouter(CaseInfo)
)
;


const
    LargeBtn = (props) =>
        <Button variant={"outlined"} color={"secondary"} style={{fontSize: "20px", padding: "16px"}} {...props}>
            {props.children}
        </Button>
